import { Grid, IconButton, styled, TypographyProps } from '@mui/material';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import TruncatedTypographicText from 'src/components/truncated-typographic-text';

interface ItemHeaderProps {
  /**
   * Name of the product (PPG/SKU)
   */
  name: string;
  /**
   * Image URL of the product (PPG/SKU)
   */
  imgSrc: string;
  /**
   * Should the image be visible (Hidden in case of SKU)
   */
  showImage: boolean;
  isOpen: boolean;
  isExpandable: boolean;
  onExpandToggleClick: () => void;
  // eslint-disable-next-line react/require-default-props
  imageSize?: 'small' | 'medium' | 'large';
  // eslint-disable-next-line react/require-default-props
  textProps?: TypographyProps;
}

const StyledDiv = styled('div')(() => ({
  borderRadius: '50%',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  border: '1px solid #0000a0'
}));

/**
 * Renders the header part in the details box shown for a particular PPG or SKU
 * The name of the product and image
 */
export default function ItemHeader({
  name,
  imgSrc,
  isExpandable,
  isOpen,
  onExpandToggleClick: toggleExpandableState,
  showImage = true,
  imageSize = 'medium',
  textProps = {}
}: ItemHeaderProps) {
  return (
    <Grid container>
      {showImage ? (
        <Grid item xs='auto' mr={1}>
          <StyledDiv
            style={{
              height:
                imageSize === 'large'
                  ? '60px'
                  : imageSize === 'small'
                  ? '30px'
                  : '40px',
              width:
                imageSize === 'large'
                  ? '60px'
                  : imageSize === 'small'
                  ? '30px'
                  : '40px',
              backgroundImage: `url(${
                imgSrc || '/static/images/logo/apple-touch-icon-120x120.png'
              })`
            }}
          />
        </Grid>
      ) : null}
      <Grid item xs style={{ margin: 'auto' }}>
        <TruncatedTypographicText
          fontSize={showImage ? '12px' : '10px'}
          fontWeight={700}
          textTransform='uppercase'
          {...textProps}
        >
          {name}
        </TruncatedTypographicText>
      </Grid>
      {isExpandable ? (
        <Grid item xs='auto'>
          <IconButton
            aria-label='delete'
            size='small'
            color='primary'
            onClick={toggleExpandableState}
          >
            {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
          </IconButton>
        </Grid>
      ) : null}
    </Grid>
  );
}
